// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_senhaCertificado__uYrLl {
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
}

.styles_container_upload__g-8C8 {
  align-items: center;
  background: #dfdddd;
  border: 3.5px dashed #18316e;
  border-radius: 8px;
  color: #868686;
  display: flex;
  flex-direction: column;
  height: 200px;
  justify-content: center;
  margin-bottom: 0.3rem;
  position: relative;
  transition: 500ms all;
  width: 100%;
  &:hover {
    background: #c7c7c7;
    border-color: #1f3a7e;
    color: #5e5d5d;
  }
}

.styles_paragrafo__0LM22{
  margin-top: 1rem;
}

.styles_input__rtU73 {
  cursor: pointer;
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
}

.styles_btnManual__ePBd3{
  background: #18316e !important;
  color: white !important;
  &:hover{
    background: #1f3a7e !important;
  }
}

.styles_btn_visualizador__wokUQ {
  background: #18316e !important;
  &:hover {
    background: #1f3a7e !important;
  }
}

.styles_container_btn__xsR9F {
  display: flex !important;
  justify-content: space-between !important;
  margin-top: 1rem;
  padding: 0 !important;
}

.styles_btn_close__\\+1mwU {
  border: 2px solid #18316e !important;
  color: #18316e !important;
  transition: 500ms all !important;
  &:hover {
    background: #18316e !important;
    border: 2px solid #18316e !important;
    color: #fff !important;
  }
}

.styles_btn_avancar__QOVar {
  background: #18316e !important;
}

.styles_labelField__Qo0qX {
  font-family: "Inter" !important;
  font-size: 12px;
}

.styles_btnDiscreto__yakCP{
  color: #7c7c7c !important;
  font-size: .8rem !important;
}

.styles_containerBtnCertificado__qt8TF{
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.styles_btnProcuracao__32vxn{
  background: #18316e !important;
  color: white !important;
  margin: .5rem 0;
  &:hover{
    background: #1f3a7e !important;
  }
}

.styles_containerDocumento__MtaIx{
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
  width: 100%;
}

.styles_documento__YO\\+Fq{
  max-width: 30rem;
}


.styles_botaoUpload__squSq,
.styles_botaoUploadOk__yR2C7 {
  height: 2.5rem !important;
  font-size: 1rem !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-transform: capitalize !important;
  font-family: "Inter" !important;
  color: #fff !important;
}

.styles_botaoUpload__squSq {
  border-radius: 4px !important;
  background-color: #4b6fc0 !important;
}

.styles_botaoUploadOk__yR2C7 {
  background-color: #31c96f !important;
}

`, "",{"version":3,"sources":["webpack://./src/pages/SelecionarTiposNegocio/ModalArquivos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,8BAA8B;EAC9B;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;EACxB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".senhaCertificado {\n  display: flex;\n  flex-direction: column;\n  margin: 1rem 0;\n}\n\n.container_upload {\n  align-items: center;\n  background: #dfdddd;\n  border: 3.5px dashed #18316e;\n  border-radius: 8px;\n  color: #868686;\n  display: flex;\n  flex-direction: column;\n  height: 200px;\n  justify-content: center;\n  margin-bottom: 0.3rem;\n  position: relative;\n  transition: 500ms all;\n  width: 100%;\n  &:hover {\n    background: #c7c7c7;\n    border-color: #1f3a7e;\n    color: #5e5d5d;\n  }\n}\n\n.paragrafo{\n  margin-top: 1rem;\n}\n\n.input {\n  cursor: pointer;\n  height: 100%;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n}\n\n.btnManual{\n  background: #18316e !important;\n  color: white !important;\n  &:hover{\n    background: #1f3a7e !important;\n  }\n}\n\n.btn_visualizador {\n  background: #18316e !important;\n  &:hover {\n    background: #1f3a7e !important;\n  }\n}\n\n.container_btn {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-top: 1rem;\n  padding: 0 !important;\n}\n\n.btn_close {\n  border: 2px solid #18316e !important;\n  color: #18316e !important;\n  transition: 500ms all !important;\n  &:hover {\n    background: #18316e !important;\n    border: 2px solid #18316e !important;\n    color: #fff !important;\n  }\n}\n\n.btn_avancar {\n  background: #18316e !important;\n}\n\n.labelField {\n  font-family: \"Inter\" !important;\n  font-size: 12px;\n}\n\n.btnDiscreto{\n  color: #7c7c7c !important;\n  font-size: .8rem !important;\n}\n\n.containerBtnCertificado{\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n}\n\n.btnProcuracao{\n  background: #18316e !important;\n  color: white !important;\n  margin: .5rem 0;\n  &:hover{\n    background: #1f3a7e !important;\n  }\n}\n\n.containerDocumento{\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.documento{\n  max-width: 30rem;\n}\n\n\n.botaoUpload,\n.botaoUploadOk {\n  height: 2.5rem !important;\n  font-size: 1rem !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-transform: capitalize !important;\n  font-family: \"Inter\" !important;\n  color: #fff !important;\n}\n\n.botaoUpload {\n  border-radius: 4px !important;\n  background-color: #4b6fc0 !important;\n}\n\n.botaoUploadOk {\n  background-color: #31c96f !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"senhaCertificado": `styles_senhaCertificado__uYrLl`,
	"container_upload": `styles_container_upload__g-8C8`,
	"paragrafo": `styles_paragrafo__0LM22`,
	"input": `styles_input__rtU73`,
	"btnManual": `styles_btnManual__ePBd3`,
	"btn_visualizador": `styles_btn_visualizador__wokUQ`,
	"container_btn": `styles_container_btn__xsR9F`,
	"btn_close": `styles_btn_close__+1mwU`,
	"btn_avancar": `styles_btn_avancar__QOVar`,
	"labelField": `styles_labelField__Qo0qX`,
	"btnDiscreto": `styles_btnDiscreto__yakCP`,
	"containerBtnCertificado": `styles_containerBtnCertificado__qt8TF`,
	"btnProcuracao": `styles_btnProcuracao__32vxn`,
	"containerDocumento": `styles_containerDocumento__MtaIx`,
	"documento": `styles_documento__YO+Fq`,
	"botaoUpload": `styles_botaoUpload__squSq`,
	"botaoUploadOk": `styles_botaoUploadOk__yR2C7`
};
export default ___CSS_LOADER_EXPORT___;
